<template>
  <div>
    <div v-if="!loading">
      <TextFormGroup
          :value="value.text"
          name="text"
          label="Text"
          :error="(errors.text || [])[0]"
          @input="emit('text', $event)"
      />

      <NumberFormGroup
          :value="value.limit"
          name="limit"
          label="Limit"
          :error="(errors.limit || [])[0]"
          help-text="The number of items to display."
          @input="emit('limit', $event)"
      />

      <SelectFormGroup
          :value="value.content_article_label_id"
          name="content_article_label_id"
          label="Content Article Label"
          :error="(errors.content_article_label_id || [])[0]"
          :options="contentArticleLabelOptions"
          :nullable="true"
          @input="emit('content_article_label_id', $event)"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {NumberFormGroup, SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      contentArticleLabels: null,

      shared: store,
      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    contentArticleLabelOptions() {
      return this.contentArticleLabels.map(contentArticleLabel => {
        return {
          value: contentArticleLabel.id,
          label: contentArticleLabel.attributes.name
        }
      })
    }
  },

  methods: {
    load() {
      http.get('/api/v2/content-article-labels', {'filter[portal_id]': this.portal.id}).then(response => {
        this.contentArticleLabels = response.data.data

        this.loading = false
      })
    },

    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
